export type Variant =
  | 'stroke'
  | 'solid'
  | 'membership'
  | 'stroke-green'
  | 'stroke-orange'
  | 'solid-orange'
  | 'solid-green';

export function getBannerStyles(variant: Variant) {
  switch (variant) {
    case 'solid':
      return {
        title: 'text-inverse',
        banner: 'bg-blue-1100',
        button: 'bg-secondary-air text-normal',
      };
    case 'membership':
      return {
        title: 'text-bonuspackGreen-text',
        banner: 'bg-[#F0FFF9] border border-[#21AB73]',
        button: 'bg-primary-regular text-inverse',
      };
    case 'stroke-green':
      return {
        title: 'text-normal',
        banner: 'bg-success-air border border-success-regular',
        button: 'bg-primary-regular text-inverse',
      };
    case 'stroke-orange':
      return {
        title: 'text-normal',
        banner: 'bg-discovery-air border border-discovery-regular',
        button: 'bg-primary-regular text-inverse',
      };
    case 'solid-orange':
      return {
        title: 'text-gray-000',
        banner: 'bg-discovery-regular border border-discovery-regular',
        button: 'bg-secondary-air text-normal',
      };
    case 'solid-green':
      return {
        title: 'text-gray-000',
        banner: 'bg-green-700 border border-green-700',
        button: 'bg-secondary-air text-normal',
      };

    case 'stroke':
    default:
      return {
        title: 'text-paragraph',
        banner: 'bg-primary-air border border-blue-600',
        button: 'bg-primary-regular text-inverse',
      };
  }
}

export function getFloatingStyles(variant: Variant) {
  switch (variant) {
    case 'stroke':
      return {
        title: 'text-paragraph',
        banner: 'border border-blue-600 bg-[rgba(243,250,255,0.95)]',
        close: '',
      };
    case 'solid':
      return {
        title: 'text-inverse',
        banner: 'bg-[rgba(20,60,151,0.95)]',
        close: 'text-gray-000',
      };
    case 'membership':
      return {
        title: 'text-[#008745]',
        banner: 'border border-[#21AB73] bg-[rgba(240,255,249,0.95)]',
        close: '',
      };
    case 'stroke-green':
      return {
        title: 'text-normal',
        banner: 'bg-success-air border border-success-regular',
        close: '',
      };
    case 'stroke-orange':
      return {
        title: 'text-normal',
        banner: 'bg-discovery-air border border-discovery-regular',
        close: '',
      };
    case 'solid-orange':
      return {
        title: 'text-gray-000',
        banner: 'bg-discovery-regular border border-discovery-regular',
        close: '',
      };
    case 'solid-green':
      return {
        title: 'text-gray-000',
        banner: 'bg-green-700 border border-green-700',
        close: '[&>svg>path]:fill-gray-000',
      };
    default:
      return {
        title: 'text-paragraph',
        banner: 'border border-blue-600 bg-[rgba(243,250,255,0.95)]',
        close: '',
      };
  }
}
